import { CartService } from '@/data/services/cart.service';
import { CustomerService } from '@/data/services/customer.service';
import { I18NService } from '@/data/services/i18n.service';
import { ShopService } from '@/data/services/shop.service';
import { TaxonomyService } from '@/data/services/taxonomy.service';
import { WishlistService } from '@/data/services/wishlist.service';
import { AuthService, CrudService, ServiceContainer } from 'yellowfin-ui-lib';

import { CatalogService } from '../data/services/catalog.service';
import { DownloadService } from '../data/services/download.service';

const container = new ServiceContainer();
container.set('CrudService', CrudService);
container.set('AuthService', AuthService);
container.set('CatalogService', CatalogService);
container.set('DownloadService', DownloadService);
container.set('CartService', CartService);
container.set('CustomerService', CustomerService);
container.set('ShopService', ShopService);
container.set('WishlistService', WishlistService);
container.set('I18NService', I18NService);
container.set('TaxonomyService', TaxonomyService)


export default container
